import { HorizontalRule } from './HorizontalRule.styled';

export default HorizontalRule;
